module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "light": ""
    }
  }, [(_vm.loggedAlready && _vm.config.IS_USER_ACTIVE && _vm.config.IS_USER_LINKED) ? _c('v-navigation-drawer', {
    staticClass: "grey lighten-4",
    attrs: {
      "fixed": "",
      "app": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('img', {
    staticClass: "pl-3",
    attrs: {
      "height": "30",
      "src": "/static/img/logo/smartility_admin.png"
    }
  })]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    staticClass: "pt-0",
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.items), function(item, i) {
    return [(item.heading) ? _c('v-layout', {
      key: i,
      attrs: {
        "row": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [(item.heading) ? _c('v-subheader', [_vm._v("\n            " + _vm._s(item.heading) + "\n          ")]) : _vm._e()], 1)], 1) : (item.children.length) ? _c('v-list-group', {
      attrs: {
        "prepend-icon": item.icon,
        "no-action": ""
      },
      model: {
        value: (item.model),
        callback: function($$v) {
          _vm.$set(item, "model", $$v)
        },
        expression: "item.model"
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.text))])], 1)], 1), _vm._v(" "), _vm._l((item.children), function(child, i) {
      return _c('v-list-tile', {
        key: i,
        attrs: {
          "to": {
            path: '/' + child.url
          }
        }
      }, [(child.icon) ? _c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(child.icon))])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', {
        on: {
          "click": function($event) {
            return _vm.saveTrackScreenAccess(child)
          }
        }
      }, [_c('v-list-tile-title', [_vm._v("\n          " + _vm._s(child.text) + "\n        ")])], 1)], 1)
    })], 2) : _c('v-list-tile', {
      attrs: {
        "to": {
          path: '/' + item.url
        }
      },
      on: {
        "click": function($event) {}
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', {
      on: {
        "click": function($event) {
          return _vm.saveTrackScreenAccess(item)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v("\n        " + _vm._s(item.text) + "\n      ")])], 1)], 1)]
  })], 2), _vm._v(" "), _c('v-card', [_c('v-card-text', {
    staticClass: "pa-0"
  }, [(_vm.commList.length === 1) ? _c('div', {
    staticClass: "pa-3 title"
  }, [_c('span', [_vm._v(_vm._s(_vm.config.COMM_NAME))])]) : _c('div', [_c('v-select', {
    staticClass: "pa-1 title",
    attrs: {
      "items": _vm.commList.filter(function (rec) { return rec.is_active; }).map(function (rec) { return rec.comm_name; }),
      "hide-details": "",
      "solo": "",
      "flat": ""
    },
    on: {
      "input": function($event) {
        _vm.loadComm(_vm.commList.find(function (rec) { return rec.comm_name === _vm.choosenComm; }))
      }
    },
    model: {
      value: (_vm.choosenComm),
      callback: function($$v) {
        _vm.choosenComm = $$v
      },
      expression: "choosenComm"
    }
  })], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.loggedAlready) ? _c('v-toolbar', {
    attrs: {
      "color": "primary",
      "dark": "",
      "fixed": "",
      "app": "",
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [(_vm.config.IS_USER_ACTIVE && _vm.config.IS_USER_LINKED && (_vm.$route.path.includes('/dashboard') || _vm.$route.path.includes('/visitors'))) ? _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }, [_c('v-icon', [_vm._v("menu")])], 1) : (!_vm.$route.path.includes('/dashboard')) ? _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$router.go(-1)
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")])], 1) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$route.meta.title) + "\n    "), (_vm.$route.path.includes('/visitors') && _vm.config.SECURITY_POST) ? _c('span', {
    staticClass: "warning--text px-2"
  }, [_vm._v("\n      [" + _vm._s(_vm.config.SECURITY_POST) + "]\n    ")]) : _vm._e()])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.config.IS_USER_ACTIVE && _vm.config.IS_USER_LINKED) ? _c('v-menu', {
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    attrs: {
      "to": {
        path: '/profile'
      }
    }
  }, [_c('v-list-tile-title', [_vm._v("Profile")])], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": _vm.logout
    }
  }, [_c('v-list-tile-title', [_vm._v("Logout")])], 1)], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-content', {
    staticClass: "white"
  }, [_c('router-view')], 1), _vm._v(" "), _c('v-bottom-nav', {
    attrs: {
      "fixed": "",
      "value": _vm.selectedItems.length && _vm.$vuetify.breakpoint.smAndDown && _vm.loggedAlready && _vm.config.IS_USER_ACTIVE && _vm.config.IS_USER_LINKED && _vm.$route.path.includes('/dashboard'),
      "active": _vm.curBot
    },
    on: {
      "update:active": function($event) {
        _vm.curBot = $event
      }
    }
  }, [_vm._l((_vm.selectedItems), function(item, i) {
    return [_c('v-bottom-sheet', {
      attrs: {
        "inset": ""
      },
      model: {
        value: (item.botModel),
        callback: function($$v) {
          _vm.$set(item, "botModel", $$v)
        },
        expression: "item.botModel"
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "flat": "",
        "value": item.text
      },
      slot: "activator"
    }, [_c('span', {
      staticClass: "secondary--text"
    }, [_vm._v(_vm._s(item.text) + " ")]), _vm._v(" "), _c('v-icon', {
      staticClass: "accent--text"
    }, [_vm._v(_vm._s(item.icon) + " ")])], 1), _vm._v(" "), _c('v-list', _vm._l((item.children), function(child, c) {
      return _c('v-list-tile', {
        key: c,
        attrs: {
          "to": {
            path: '/' + child.url
          }
        },
        on: {
          "click": function($event) {
            item.botModel = false
          }
        }
      }, [_c('v-list-tile-avatar', [_c('v-icon', {
        staticClass: "accent--text"
      }, [_vm._v(_vm._s(child.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
        staticClass: "body-1 secondary--text"
      }, [_vm._v(_vm._s(child.text))])], 1)
    }), 1)], 1)]
  })], 2), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "400px",
      "persistent": ""
    },
    model: {
      value: (_vm.dlgPush),
      callback: function($$v) {
        _vm.dlgPush = $$v
      },
      expression: "dlgPush"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n      Wait!\n    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-0"
  }, [_c('div', {
    staticClass: "subheading"
  }, [_vm._v("You are not subscribed to push notification yet.")]), _vm._v(" "), _c('div', {
    staticClass: "mt-3"
  }, [_vm._v("\n        Choose the option \"allow\" when you prompted next and start receiving important alerts from Uniservice Application.\n      ")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-1"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dlgPush = false
      }
    }
  }, [_vm._v("Remind Me Later")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.reqBrowserPromptForPush()
      }
    }
  }, [_vm._v("Proceed")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a4aca40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 702
// module chunks = 30